import React from 'react';
import { AppContextState } from '@/entities/AppContextState';

export const AppContext = React.createContext<AppContextState>({
  language: 'en-US',
  showLanguageTip: false,
  updateAppContext: () => {},
});
